import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import Loader from './Loader';

const ProtectedRoute = ({
  component: Component,
  children,
  showRoute,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (showRoute === undefined || showRoute === null) {
        return <Loader />;
      }
      if (!showRoute) {
        return <Redirect to="/404" />;
      }
      if (Component) {
        return <Component {...props} />;
      }
      return children || null;
    }}
  />
);

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func
  ]),
  children: PropTypes.node,
  showRoute: PropTypes.bool
};

export default ProtectedRoute;
